module.exports = __webpack_public_path__ + "img/Feldlager.1451312f.svg";